import { CssBaseline, ThemeProvider } from "@mui/material";
import React from "react";
import { Provider, useSelector } from "react-redux";
import { Route, Routes, useLocation } from "react-router-dom";
import { store } from "../redux/store";
import Login from "../screen/auth/Login";
import Signup from "../screen/auth/Signup";
import ForgotPassword from "../screen/auth/forgot";
import SideBar from "../screen/global/Side";
import TopBar from "../screen/global/Top";
import { createCustomTheme } from "../theme";

import Dashboard from "../screen/Dashboard";
import Logout from "../screen/Logout";
import WholesalerDashboard from "../screen/WholesalerDashboard";
import AddClub from "../screen/admin/bar/club/AddClub";
import EditClub from "../screen/admin/bar/club/EditClub";
import ViewClub from "../screen/admin/bar/club/ViewBarClub";

import AddWholeSalerAggregation from "../screen/admin/wholesaler/AddWholeSaler";
import EditWholeSalerAggregation from "../screen/admin/wholesaler/EditWholeSaler";
import ViewWholeSaler from "../screen/admin/wholesaler/ViewWholesaler";

import AddCustomer from "../screen/admin/Customer/AddCustomer";
import EditCustomer from "../screen/admin/Customer/EditCustomer";
import Customers from "../screen/admin/Customer/GeneralCustomerList";
import ViewCustomer from "../screen/admin/Customer/ViewCustomer";

import "react-perfect-scrollbar/dist/css/styles.css";
import OnBoardedWholeSaler from "../screen/admin/wholesaler/OnBoardedWholeSaler";
import { APP_LINK } from "../screen/global/MenuItems";
import WholeSalerSideBar from "../screen/global/WholesalerSide";
import { APP_LINKS } from "../screen/global/wholeSalerMenuItems";
import "../themes.css";

import EditAdmin from "../screen/admin/profile/EditAdmin";

import AddProduct from "../screen/admin/product/AddProduct";
import EditProduct from "../screen/admin/product/EditProduct";
import Permission from "../screen/admin/product/PermissionList";
import ProductList from "../screen/admin/product/ProductList";
import ProductView from "../screen/admin/product/ViewProduct";

import BrandList from "../screen/admin/brand/BrandList";
import TypeOfAlcohol from "../screen/admin/typeOfAlcohol/TypeOfAlcoholList";
import ProductQuantityList from "../screen/wholesalers/ProductQuantity/productQuantityList";

import SalesReport from "../screen/admin/Report/Report";

import ChangePassword from "../screen/auth/changePassword";
import OTPVerifyRegister from "../screen/auth/verifyOtp";
import BarClubAggregation from "../screen/admin/bar/club/BarClubAggregation";
import CustomerList from "../screen/wholesalers/customer/GeneralCustomerList";
import ProductAdd from "../screen/wholesalers/product/AddProduct";
import ProductEdit from "../screen/wholesalers/product/EditProduct";
import ViewProduct from "../screen/wholesalers/product/ViewProduct";
import ListProduct from "../screen/wholesalers/product/ProductList";
import WholeSalerEdit from "../screen/wholesalers/wholesaler/EditWholeSaler";
import WholeSalerView from "../screen/wholesalers/wholesaler/ViewWholeSaler";
import {
  default as SalesReportForm,
  default as WholeSalerReportWholeSaler,
} from "../screen/wholesalers/wholesaler/WholesalerSalesReport";

import BarAdd from "../screen/wholesalers/bar/AddClub";
import BarList from "../screen/wholesalers/bar/BarClubAggregation";
import BarEdit from "../screen/wholesalers/bar/EditClub";
import BarView from "../screen/wholesalers/bar/ViewBarClub";

import ConsumedList from "../screen/wholesalers/transaction/consumptionShots";
import TransactionList from "../screen/wholesalers/transaction/transationList";
import MobileOTPVerify from "../screen/auth/mobileOtp";

const RoutesComponent = () => {
  const location = useLocation();
  const themeSettings = createCustomTheme();
  const userType = useSelector(
    (state) => state?.values?.loginValues?.[0]?.user_type
  );
  const RenderSidebar = () => {
    switch (userType) {
      case "3":
        return <WholeSalerSideBar />;
      case "1":
        return <SideBar />;
      default:
        return null;
    }
  };
  const isAuthPage =
    location.pathname === APP_LINK.LOGIN ||
    location.pathname === APP_LINK.REGISTER ||
    location.pathname === APP_LINK.FORGOTPASSWORD ||
    location.pathname === APP_LINKS.OTPVERIFYREGISTER ||
    location.pathname === APP_LINKS.MOBILEOTPVERIFY;

  return (
    <Provider store={store}>
      <ThemeProvider theme={themeSettings}>
        <CssBaseline />
        <div className="app">
          {!isAuthPage && RenderSidebar()}
          <main className="content">
            {!isAuthPage && <TopBar />}
            <div className="content">
              <Routes>
                <Route path={APP_LINK.LOGIN} element={<Login />} />
                <Route path={APP_LINK.REGISTER} element={<Signup />} />
                <Route
                  path={APP_LINK.FORGOTPASSWORD}
                  element={<ForgotPassword />}
                />
                <Route path={APP_LINK.DASHBOARD} element={<Dashboard />} />
                <Route path={APP_LINK.EDITADMIN} element={<EditAdmin />} />
                <Route path={APP_LINK.ADDPRODUCT} element={<AddProduct />} />
                <Route path={APP_LINK.EDITPRODUCT} element={<EditProduct />} />
                <Route path={APP_LINK.VIEWPRODUCT} element={<ProductView />} />
                <Route path={APP_LINK.PRODUCTLIST} element={<ProductList />} />
                <Route path={APP_LINK.PERMISSION} element={<Permission />} />

                <Route path={APP_LINK.BRANDLIST} element={<BrandList />} />

                <Route
                  path={APP_LINKS.PRODUCTQUANTITYLIST}
                  element={<ProductQuantityList />}
                />
                <Route
                  path={APP_LINK.TYPEOFALCOHOLLIST}
                  element={<TypeOfAlcohol />}
                />

                <Route
                  path={APP_LINK.ADDWHOLESALER}
                  element={<AddWholeSalerAggregation />}
                />
                <Route
                  path={APP_LINK.EDITWHOLESALER}
                  element={<EditWholeSalerAggregation />}
                />
                <Route
                  path={APP_LINK.VIEWWHOLESALER}
                  element={<ViewWholeSaler />}
                />
                <Route
                  path={APP_LINK.ONBOARDEDWHOLESALER}
                  element={<OnBoardedWholeSaler />}
                />
                <Route
                  path={APP_LINK.ADDBARAGGREGATION}
                  element={<AddClub />}
                />
                <Route
                  path={APP_LINK.EDITBARAGGREGATION}
                  element={<EditClub />}
                />
                <Route
                  path={APP_LINK.VIEWBARAGGREGATION}
                  element={<ViewClub />}
                />
                <Route
                  path={APP_LINK.BARCLUBAGGREGATION}
                  element={<BarClubAggregation />}
                />
                <Route path={APP_LINK.ADMINREPORT} element={<SalesReport />} />
                <Route
                  path={APP_LINKS.CONSUMEDREPORT}
                  element={<ConsumedList />}
                />
                <Route
                  path={APP_LINKS.TRANSATIONSlIST}
                  element={<TransactionList />}
                />
                <Route path={APP_LINK.ADDCUSTOMER} element={<AddCustomer />} />
                <Route
                  path={APP_LINK.EDITCUSTOMER}
                  element={<EditCustomer />}
                />
                <Route
                  path={APP_LINK.VIEWCUSTOMER}
                  element={<ViewCustomer />}
                />
                <Route path={APP_LINK.CUSTOMERS} element={<Customers />} />
                <Route path={APP_LINK.LOGOUT} element={<Logout />} />
                <Route path={APP_LINKS.ADDPRODUCT} element={<ProductAdd />} />
                <Route path={APP_LINKS.PRODUCTEDIT} element={<ProductEdit />} />
                <Route
                  path={APP_LINKS.WHOLESALERDASHBOARD}
                  element={<WholesalerDashboard />}
                />
                <Route
                  path={APP_LINKS.PRODUCTDETAIL}
                  element={<ViewProduct />}
                />
                <Route path={APP_LINKS.PRODUCTLIST} element={<ListProduct />} />
                <Route
                  path={APP_LINKS.CUSTOMERLIST}
                  element={<CustomerList />}
                />
                <Route
                  path={APP_LINK.VIEWCUSTOMER}
                  element={<SalesReportForm />}
                />
                <Route
                  path={APP_LINKS.WHOLESALERREPORT}
                  element={<WholeSalerReportWholeSaler />}
                />
                <Route
                  path={APP_LINK.CHANGEPASSWORD}
                  element={<ChangePassword />}
                />
                <Route
                  path={APP_LINKS.EDITWHOLESALER}
                  element={<WholeSalerEdit />}
                />
                <Route
                  path={APP_LINKS.VIEWWHOLESALER}
                  element={<WholeSalerView />}
                />
                <Route
                  path={APP_LINKS.OTPVERIFYREGISTER}
                  element={<OTPVerifyRegister />}
                />
                <Route
                  path={APP_LINKS.MOBILEOTPVERIFY}
                  element={<MobileOTPVerify />}
                />
                <Route
                  path={APP_LINKS.ADDBARAGGREGATION}
                  element={<BarAdd />}
                />
                <Route
                  path={APP_LINKS.EDITBARAGGREGATION}
                  element={<BarEdit />}
                />
                <Route
                  path={APP_LINKS.BARCLUBAGGREGATION}
                  element={<BarList />}
                />
                <Route
                  path={APP_LINKS.VIEWBARAGGREGATION}
                  element={<BarView />}
                />
              </Routes>
            </div>
          </main>
        </div>
      </ThemeProvider>
    </Provider>
  );
};

export default RoutesComponent;
